import { HealthStatus, Operation, OperationType, PlanStatus, StatusEntity, TagStatus } from '@admin/core/models';
import { ItemRecord } from '@controladad/ng-base';

export const StatusValues: ItemRecord<StatusEntity>[] = [
  { value: StatusEntity.Enabled, label: 'فعال' },
  { value: StatusEntity.Disabled, label: 'غیرفعال' },
];

export const TagStatusValues: ItemRecord<TagStatus>[] = [
  { value: TagStatus.WithoutTag, label: 'بدون تگ' },
  { value: TagStatus.PendingAttachment, label: 'در انتظار الصاق' },
  { value: TagStatus.PendingApproval, label: 'در انتظار تایید' },
  { value: TagStatus.Damaged, label: 'مخدوش' },
  { value: TagStatus.HasTag, label: 'دارای تگ' },
];

export const HealthValues: ItemRecord<HealthStatus>[] = [
  { value: HealthStatus.Healthy, label: 'سالم' },
  { value: HealthStatus.OutOfService, label: 'خارج از سرویس' },
  { value: HealthStatus.NeedsMaintenance, label: 'نیازمند تعمیر' },
  { value: HealthStatus.Unknown, label: 'نامشخص' },
];

export const PlanStatusValues: ItemRecord<PlanStatus>[] = [
  { value: PlanStatus.Paused, label: 'متوقف' },
  { value: PlanStatus.Closed, label: 'بسته شده' },
  { value: PlanStatus.Pending, label: 'در انتظار' },
  { value: PlanStatus.Started, label: 'شروع شده' },
];

export const SyncValues: ItemRecord<boolean>[] = [
  { value: true, label: 'سینک شده' },
  { value: false, label: 'سینک نشده' },
];


export const YesNoValues: ItemRecord<boolean>[] = [
  { value: true, label: 'بله' },
  { value: false, label: 'خیر' },
];


export const OperationValues: ItemRecord<Operation>[] = [
  { value: Operation.Input, label: 'ورودی' },
  { value: Operation.Output, label: 'خروجی' },
  { value: Operation.Transmission, label: 'انتقال' },
];

export const OperationTypeValues: ItemRecord<OperationType>[] = [
  { value: OperationType.Discovery, label: 'کشف' },
  { value: OperationType.Disposal, label: 'اسقاط' },
  { value: OperationType.Missing, label: 'مفقودی' },
  { value: OperationType.Location, label: 'مکان' },
  { value: OperationType.Custodian, label: 'تحویل گیرنده' },
  { value: OperationType.Both, label: 'مکان و تحویل گیرنده' },
];